<template lang="pug">
ul.legislacion_relacionada_results
  li.section_two_item(v-if="documents.length == 0")
    | {{ t('results_not_found') }}
  li.section_two_item(v-else v-for="document in documents" :key="document.id")
    span(:href="documentLink(document)" :title="document.title" @click="openDocument(document)")
      | {{ truncateTitle(document.title) }}
    ul
      li(v-for="article in document.articles"
          class="tooltip_legislacion_relacionada clasificacionSectionTwo"
          :id="articleId(article)"
          :key="article.id"
          :itemid="article.docid"
          :itemartnum="article.article_num"
          :itemindice="article.virtual_index")
        span(:title="truncateText(article.text)" @click="openArticle(document, article)")
          | {{ truncateTitle(article.title) }}
</template>

<script>
import mixins from 'common/mixins.js'
import constants from 'common/constants.js'
import { truncate, truncateWithSuffix } from 'common/string_utils.js'

export default {
  name: 'links-quotes-vue',
  props: {
    documents: Array,
  },
  mixins: [mixins.translate],
  methods: {
    documentLink(document) {
      var path = `/${document.tolgeo}/documento${this.suffix(document.tolgeo)}/show`
      return `${path}/${document.id}?tolgeo=${document.tolgeo}`
    },
    suffix(tolgeo) {
      return tolgeo === 'latam' ? 'Latam' : ''
    },
    articleId(article) {
      return `article_${article.id}`
    },
    openDocument(document) {
      var event = new CustomEvent('document-quick-view', { detail: { documentId: document.id }})
      window.parent.document.dispatchEvent(event)
    },
    openArticle(document, article) {
      if (article.docid != document.id) {
        // Physical splitting
        var documentEvent = new CustomEvent('document-quick-view', { detail: { documentId: article.docid }})
        window.parent.document.dispatchEvent(documentEvent)
        return
      }
      // Virtual splitting
      var event = new CustomEvent('article-quick-view', { detail: article })
      window.parent.document.dispatchEvent(event)
    },
    truncateText(text) {
      return truncate(text, constants.MAX_TEXT_LENGTH)
    },
    truncateTitle(title) {
      return truncateWithSuffix(title, constants.MAX_TITLE_LENGTH)
    }
  }
}
</script>
